import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import React, { useRef, useState, useEffect } from 'react';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import user_icon from "../../../images/reg_user.png";
import document_icon from "../../../images/document_icon.png";
import address_icon from "../../../images/address_icon.png";
import identity_icon from "../../../images/identity_icon.png";
import Header from '../../Includes/Header';
import { useNavigate } from 'react-router-dom';
import countriesStateData from '../../../data/states.json';
import edit_icon from "../../../images/pencil_icon.png";
import { EditOutlined, AccountCircle, DescriptionOutlined, BadgeOutlined, HomeOutlined, FactCheckOutlined, CancelOutlined } from '@mui/icons-material';
import questionnaire_icon from "../../../images/questionnaire_edit_icon.png";
import HelpBtn from '../../Includes/HelpBtn';
import BackButton from '../../Includes/BackButtonEntityAccount';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../../renderField';
import { connect } from 'react-redux';
import { setwizardPageName, setCheckPage, setCertificationDetails, setUploadDocumentDetails, setBusinessAddressDetails, setPhysicalBusinessAddressDetails, setAccountUseDetails, setAuthorizedRepresentativeDetails, setwizardPageNumber } from '../../EntityAccountReducer';
import { RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import countriesData from '../../../data/countries.json';
import { notifySuccess } from 'MyComponents/Toaster';
import SelfieCameraModal from '../../Camera/SelfieCameraModal';
import MemberSummaryCard from './MemberSummaryCard';
import MultiFileSelector from "./FilePicker";
import red_cross_icon from "../../../images/circle_cross.png";
import { updateEntityKycDraftStep, submitEntityKycDraft } from "../../../Utils/entityKycDraft";
import Spacer from 'MyComponents/UI/Spacer';
import CustomMultiLineTextArea from './CustomMultiLineTextArea';
import { useTranslation } from 'react-i18next';
import config from '../../../config';

// Module-level guard: survives component remounts (unlike useRef)
let _summaryFetchedForUser: string | null = null;

interface Props { };

const renderCustomMultiLineTextArea = React.forwardRef(({ input, meta, ...rest }: any, ref: any) => (
  <div ref={ref}>
    <CustomMultiLineTextArea
      {...rest}
      initialValue={input.value}
      onChange={(val: string) => input.onChange(val)}
    />
  </div>
));

interface CheckboxState {
  checkbox1: boolean;
  checkbox2: boolean;
  checkbox3: boolean;
  checkbox4: boolean;
  checkbox5: boolean;
  checkbox6: boolean;
  checkbox7: boolean;
  checkbox8: boolean;
  checkbox9: boolean;
  checkbox10: boolean;
  checkbox11: boolean;
}

const checkboxLabels: { [key: string]: string } = {
  checkbox1: 'US',
  checkbox2: 'UK',
  checkbox3: 'Africa',
  checkbox4: 'Other Oceania',
  checkbox5: 'Canada',
  checkbox6: 'EU',
  checkbox7: 'Asia',
  checkbox8: 'Not applicable',
  checkbox9: 'LATAM',
  checkbox10: 'Other Europe',
  checkbox11: 'Australia',
};

interface FormData {
  phoneno: string;
  physicalBusinessStreetAddress: string;
  physicalBusinessPostalCode: string;
  physicalBusinessCity: string;
  physicalBusinessCountry: string;
  physicalBusinessState: string;
  firstName: string;
  lastName: string;
  isBusinessDiffName: string;
  taxID: string;
  businessDateOfFormation: string;
  isBusinessWebsite: string;
  desBusinessModel: string;
  numberOfEmployees: string;
  reasonForUsingAccount: string;
  accountUseCustomerLocated: string;
  accountUseState: string;
  accountUsePostalCode: string;
  authRepFirstName: string;
  authRepLastName: string;
  authRepPhoneNumber: string;
  authRepDateOfBirth: string;
  authRepJobTitle: string;
  authRepEmail: string;
  authRepCountry: string;
  authRepSelectedFormID: string;
}
interface BusinessInfoData {
  isBusinessDiffName: string;
  taxID: string;
  businessDateOfFormation: string;
  isBusinessWebsite: string;
  desBusinessModel: string;
  numberOfEmployees: string;
}

interface DirectorsData {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  country: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  taxID: string;
  ownershipID: string;
  selectedFormID: string;
  selectedCountry: string;
}

const SummaryForm: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {

  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const page = useSelector((state: RootState) => state.entityAccount.wizardPageNumber);
  const email = useSelector((state: RootState) => state.entityAccount.email);
  const userID = useSelector((state: RootState) => state.entityAccount.userID);
  const businessAddressDetails = useSelector((state: RootState) => state.entityAccount.businessAddressDetails);
  const entityAccountBusinessDetails = useSelector((state: RootState) => state.entityAccount.entityAccountBusinessDetails);
  const physicalBusinessAddressDetails = useSelector((state: RootState) => state.entityAccount.physicalBusinessAddressDetails);
  const accountUseDetails = useSelector((state: RootState) => state.entityAccount.accountUseDetails);
  const authorizedRepresentativeDetails = useSelector((state: RootState) => state.entityAccount.authorizedRepresentativeDetails);
  const uploadDocumentsDetails = useSelector((state: RootState) => state.entityAccount.uploadDocumentDetails);
  const certificationDetails = useSelector((state: RootState) => state.entityAccount.certificationDetails);

  const invites = useSelector((state: RootState) => state.entityAccount.invites);

  const formValues = useSelector((state: RootState) => (state.form.wizardSummary as any)?.values || {});

  const [allBeneficialOwnersDeleted, setAllBeneficialOwnersDeleted] = useState(false);
  const [allDirectorsDeleted, setAllDirectorsDeleted] = useState(false);

  const [stateValidation, setStateValidation] = useState(false);
  const [dataArray, setDataArray] = useState<any[]>([]);
  const [directorsDataArray, setDirectorsDataArray] = useState<any[]>([]);

  useEffect(() => {
    dispatch(setwizardPageName("summary"));
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(invites)) {
      const beneficialOwners = invites.filter(inv => inv?.role === 'beneficialOwner' || inv?.Role === 'beneficialOwner' || inv?.userRole === 'beneficialOwner');
      const directors = invites.filter(inv => inv?.role === 'director' || inv?.Role === 'director' || inv?.userRole === 'director');
      setDataArray(beneficialOwners);
      setDirectorsDataArray(directors);
    }
  }, [invites]);

  const [businessInfoEditMode, setBusinessInfoEditMode] = useState(false);

  const businessInfoToggleEditMode = () => {
    setBusinessInfoEditMode(!businessInfoEditMode);
  };

  const [physicalBusinessInfoEditMode, setPhysicalBusinessInfoEditMode] = useState(false);

  const physicalBusinessInfoToggleEditMode = () => {
    setPhysicalBusinessInfoEditMode(!physicalBusinessInfoEditMode);
  };

  const [accountUseEditMode, setAccountUseEditMode] = useState(false);

  const accountUseToggleEditMode = () => {
    setAccountUseEditMode(!accountUseEditMode);
  };

  const initialCheckboxesState: CheckboxState = {
    checkbox1: accountUseDetails?.accountUseCustomerLocated?.includes('US') || false,
    checkbox2: accountUseDetails?.accountUseCustomerLocated?.includes('UK') || false,
    checkbox3: accountUseDetails?.accountUseCustomerLocated?.includes('Africa') || false,
    checkbox4: accountUseDetails?.accountUseCustomerLocated?.includes('Other Oceania') || false,
    checkbox5: accountUseDetails?.accountUseCustomerLocated?.includes('Canada') || false,
    checkbox6: accountUseDetails?.accountUseCustomerLocated?.includes('EU') || false,
    checkbox7: accountUseDetails?.accountUseCustomerLocated?.includes('Asia') || false,
    checkbox8: accountUseDetails?.accountUseCustomerLocated?.includes('Not Applicable') || false,
    checkbox9: accountUseDetails?.accountUseCustomerLocated?.includes('LATAM') || false,
    checkbox10: accountUseDetails?.accountUseCustomerLocated?.includes('Other Europe') || false,
    checkbox11: accountUseDetails?.accountUseCustomerLocated?.includes('Australia') || false,
  };

  const [checkboxes, setCheckboxes] = useState<CheckboxState>(initialCheckboxesState);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [id]: checked,
    }));
  };

  const [authorizedRepEditMode, setAuthorizedRepEditMode] = useState(false);

  const authorizedRepToggleEditMode = () => {
    dispatch(setwizardPageNumber(6));
    dispatch(setCheckPage('SummaryPage'));
    dispatch(setwizardPageName('authorizedRep'));
  };

  const [beneficialOwnerEditMode, setBeneficialOwnerEditMode] = useState(false);

  const beneficialOwnerToggleEditMode = () => {
    dispatch(setwizardPageNumber(6));
    dispatch(setCheckPage('SummaryPage'));
    dispatch(setwizardPageName('beneficialOwners'));
  };

  const deleteBeneficialOwner = async (id: any, accordionID: any) => {
    try {
      const updatedData = dataArray.filter((item, idx) => {
        if (item.id) return item.id !== id;
        return idx !== id;
      });

      await updateEntityKycDraftStep(userID, 'beneficialOwners', updatedData);
      setDataArray(updatedData);

      const element = document.getElementById(accordionID);
      if (element) {
        element.remove();
      }

      if (updatedData.length === 0) {
        setAllBeneficialOwnersDeleted(true);
      }
    } catch (error) {
      console.error(error);
      console.error("Failed to delete beneficial owner");
    }
  };

  useEffect(() => {}, [allBeneficialOwnersDeleted]);
  useEffect(() => {}, [allDirectorsDeleted]);

  const beneficialOwnerHandleInputChange = (index: any, fieldName: any, value: any) => {
    const updatedDataArray = [...dataArray];
    updatedDataArray[index][fieldName] = value;
    setDataArray(updatedDataArray);
  };

  const [directorEditMode, setDirectorEditMode] = useState(false);
  const [directorEditedData, setDirectorEditedData] = useState<DirectorsData>({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    country: '',
    streetAddress: '',
    city: '',
    state: '',
    postalCode: '',
    taxID: '',
    ownershipID: '',
    selectedFormID: '',
    selectedCountry: '',
  });

  const directorToggleEditMode = () => {
    dispatch(setwizardPageNumber(6));
    dispatch(setCheckPage('SummaryPage'));
    dispatch(setwizardPageName('directors'));
  };

  const deleteDirectors = async (id: any, accordionID: any) => {
    try {
      const updatedData = directorsDataArray.filter((item, idx) => {
        if (item.id) return item.id !== id;
        return idx !== id;
      });

      await updateEntityKycDraftStep(userID, 'directors', updatedData);
      setDirectorsDataArray(updatedData);

      const element = document.getElementById(accordionID);
      if (element) {
        element.remove();
      }

      if (updatedData.length === 0) {
        setAllDirectorsDeleted(true);
      }
    } catch (error) {
      console.error(error);
      console.error("Failed to delete director");
    }
  };

  const directorHandleInputChange = (index: any, fieldName: any, value: any) => {
    console.log("index", index);
    const updatedDataArray = [...directorsDataArray];
    updatedDataArray[index][fieldName] = value;
    setDirectorsDataArray(updatedDataArray);
  };

  const [uploadDocumentsEditMode, setUploadDocumentsEditMode] = useState(false);

  const uploadDocumentsToggleEditMode = () => {
    setUploadDocumentsEditMode(!uploadDocumentsEditMode);
  };

  const [certificationEditMode, setCertificationEditMode] = useState(false);

  const certificationToggleEditMode = () => {
    setCertificationEditMode(!certificationEditMode);
  };

  const getPreviewUrl = (doc: any) => {
    let url = "";
    if (Array.isArray(doc)) {
      url = doc[0]?.url || "";
    } else {
      url = doc || "";
    }
    if (url && typeof url === 'string' && !url.startsWith('data:image') && url.includes('/file/')) {
      const filename = url.split('/').pop();
      return `${config.NODE_API_BASE_URL_V2}/file/${filename}`;
    }
    return url;
  };

  const getPreviewFilename = (doc: any) => {
    if (Array.isArray(doc)) {
      return doc[0]?.filename || "";
    }
    return "";
  };

  const isImageBase64 = (url: any) => typeof url === "string" && url.startsWith("data:image");

  const getFileType = (url: string, filename: string) => {
    if (isImageBase64(url)) return "Image";
    const name = filename || url || "";
    if (name.toLowerCase().match(/\.(jpeg|jpg|gif|png|bmp|webp)$/)) return "Image";
    if (name.toLowerCase().endsWith(".pdf")) return "PDF";
    if (name.toLowerCase().endsWith(".doc") || name.toLowerCase().endsWith(".docx")) return "Word";
    return "Document";
  };

  const handleBusinessInfoSave = async () => {
    const businessAddressDetailsObject = {
      isBusinessDiffName: formValues.isBusinessDiffName,
      isBusinessWebsite: formValues.isBusinessWebsite,
      taxID: formValues.taxID,
      desBusinessModel: formValues.desBusinessModel,
      numberOfEmployees: formValues.numberOfEmployees,
      businessDateOfFormation: formValues.businessDateOfFormation
    };
    try {
      await updateEntityKycDraftStep(userID, 'businessInformation', businessAddressDetailsObject);
      dispatch(setBusinessAddressDetails(businessAddressDetailsObject));
      setBusinessInfoEditMode(false);
      console.log("Business Information updated");
    } catch (error) {
      console.error(error);
      console.error("Failed to update business information");
    }
  };

  const handleBusinessInfoCancel = () => {
    setBusinessInfoEditMode(false);
  };

  const handlePhysicalBusinessInfoSave = async () => {
    const physicalBusinessAddressDetailsObject = {
      physicalBusinessAddressCountry: formValues.physicalBusinessCountry,
      physicalBusinessAddressCity: formValues.physicalBusinessCity,
      physicalBusinessAddressState: formValues.physicalBusinessState,
      physicalBusinessAddressZip: formValues.physicalBusinessPostalCode,
      physicalBusinessStreetAddress: formValues.physicalBusinessStreetAddress,
    };
    try {
      await updateEntityKycDraftStep(userID, 'physicalBusinessAddress', physicalBusinessAddressDetailsObject);
      dispatch(setPhysicalBusinessAddressDetails(physicalBusinessAddressDetailsObject));
      setPhysicalBusinessInfoEditMode(false);
      console.log("Physical Business Address updated");
    } catch (error) {
      console.error(error);
      console.error("Failed to update physical address");
    }
  };

  const handlePhysicalBusinessInfoCancel = () => {
    setPhysicalBusinessInfoEditMode(false);
  };

  const handleAccountUseSave = async () => {
    const checkedCheckboxes = Object.entries(checkboxes)
      .filter(([key, value]) => value)
      .map(([key]) => checkboxLabels[key]);

    const accountUseCustomerLocated = checkedCheckboxes.join(',');
    const accountUseDetailsObject = {
      isBusinessWebsite: formValues.isBusinessWebsite,
      reasonForUsingAccount: formValues.reasonForUsingAccount,
      anticipatedAccoutActivity: formValues.anticipatedAccoutActivity,
      monthlyTradingVolume: formValues.monthlyTradingVolume,
      monthlyTradingValue: formValues.monthlyTradingValue,
      accountUseCustomerLocated: accountUseCustomerLocated
    };
    try {
      await updateEntityKycDraftStep(userID, 'accountUse', accountUseDetailsObject);
      dispatch(setAccountUseDetails(accountUseDetailsObject));
      setAccountUseEditMode(false);
      console.log("Account Use details updated");
    } catch (error) {
      console.error(error);
      console.error("Failed to update account use details");
    }
  };

  const handleAccountUseCancel = () => {
    setAccountUseEditMode(false);
  };

  const handleAuthorizedRepSave = async () => {
    const AuthorizedRepresentativeDetailsObject = {
      firstName: formValues.authRepFirstName,
      lastName: formValues.authRepLastName,
      dateOfBirth: formValues.authRepDateOfBirth,
      email: formValues.authRepEmail,
      phoneNumber: formValues.authRepPhoneNumber,
      jobTitle: formValues.authRepJobTitle,
      authRepCountry: formValues.authRepCountry,
      selectedFormID: formValues.authRepSelectedFormID
    };
    try {
      await updateEntityKycDraftStep(userID, 'authorizedRepresentative', AuthorizedRepresentativeDetailsObject);
      dispatch(setAuthorizedRepresentativeDetails(AuthorizedRepresentativeDetailsObject));
      setAuthorizedRepEditMode(false);
      console.log("Authorized Representative updated");
    } catch (error) {
      console.error(error);
      console.error("Failed to update authorized representative");
    }
  };

  const handleAuthorizedRepCancel = () => {
    setAuthorizedRepEditMode(false);
  };

  const handleBeneficialOwnerSaveAll = async () => {
    try {
      await updateEntityKycDraftStep(userID, 'beneficialOwners', dataArray);
      setBeneficialOwnerEditMode(false);
      console.log("Beneficial Owners updated");
    } catch (error) {
      console.error(error);
    }
  };
  const handleBeneficialOwnerSave = async (id: any, firstName: any, lastName: any, dateOfBirth: any, selectedCountry: any, streetAddress: any, city: any, selectedState: any, postalCode: any, taxpayerTaxID: any, ownershiptaxID: any, selectedFormID: any, selectedFormIDCountry: any) => {
    try {
      const updatedData = dataArray.map((item, idx) => {
        const isMatch = item.id ? item.id === id : idx === id;
        if (isMatch) {
          return {
            ...item,
            firstName, lastName, dateOfBirth, selectedCountry, streetAddress, city, selectedState, postalCode, taxpayerTaxID, ownershiptaxID, selectedFormID, selectedFormIDCountry
          };
        }
        return item;
      });

      await updateEntityKycDraftStep(userID, 'beneficialOwners', updatedData);
      setDataArray(updatedData);
      setBeneficialOwnerEditMode(false);
      console.log("Beneficial Owner updated");
    } catch (error) {
      console.error(error);
      console.error("Failed to update beneficial owner");
    }
  };

  const handleBeneficialOwnerCancel = () => {
    setBeneficialOwnerEditMode(false);
  };

  const handleDirectorSaveAll = async () => {
    try {
      await updateEntityKycDraftStep(userID, 'directors', directorsDataArray);
      setDirectorEditMode(false);
      console.log("Directors updated");
    } catch (error) {
      console.error(error);
    }
  };
  const handleDirectorSave = async (id: any, firstName: any, lastName: any, dateOfBirth: any, selectedCountry: any, streetAddress: any, city: any, selectedState: any, postalCode: any, taxpayerTaxID: any, ownershiptaxID: any, selectedFormID: any, selectedFormIDCountry: any) => {
    try {
      const updatedData = directorsDataArray.map((item, idx) => {
        const isMatch = item.id ? item.id === id : idx === id;
        if (isMatch) {
          return {
            ...item,
            firstName, lastName, dateOfBirth, selectedCountry, streetAddress, city, selectedState, postalCode, taxpayerTaxID, ownershiptaxID, selectedFormID, selectedFormIDCountry
          };
        }
        return item;
      });

      await updateEntityKycDraftStep(userID, 'directors', updatedData);
      setDirectorsDataArray(updatedData);
      setDirectorEditMode(false);
      console.log("Director updated");
    } catch (error) {
      console.error(error);
      console.error("Failed to update director");
    }
  };

  const handleDirectorCancel = () => {
    setDirectorEditMode(false);
  };

  const [directorsData, setDirectorsData] = useState([]);

  const handleUploadDocumentSave = async () => {
    const UploadDocumentDetailsObject = {
      OrganizationalDocument: uploadDocumentsDetails.organizationalDocument,
      ProofOfPhysicalBusinessAddress: uploadDocumentsDetails.proofPhysicalBusinessAddress,
      physicalBusinessAddressDocumentInfo: formValues.physicalBusinessAddressDocumentInfo
    };
    try {
      await updateEntityKycDraftStep(userID, 'uploadDocuments', UploadDocumentDetailsObject);
      dispatch(setUploadDocumentDetails(UploadDocumentDetailsObject));
      setUploadDocumentsEditMode(false);
      console.log("Documents updated");
    } catch (error) {
      console.error(error);
      console.error("Failed to update documents");
    }
  };

  const handleUploadDocumentCancel = () => {
    setUploadDocumentsEditMode(false);
  };

  const handleCertificationSave = async () => {
    if (isChecked1 && isChecked2) {
      const certificationObj = {
        certification1: isChecked1,
        certification2: isChecked2,
        certificationNotes: formValues.certificationNotes || ""
      };
      try {
        await updateEntityKycDraftStep(userID, 'certification', certificationObj);
        dispatch(setCertificationDetails(certificationObj));
        setCertificationEditMode(false);
        console.log("Certification updated");
      } catch (error) {
        console.error(error);
        console.error("Failed to update certification");
      }
    }
  };

  const handleCertificationCancel = () => {
    setCertificationEditMode(false);
  };

  const beneficialOwnerAddNew = async () => {
    dispatch(setwizardPageNumber(6));
    dispatch(setCheckPage('SummaryPage'));
    dispatch(setwizardPageName('beneficialOwners'));
  };

  const directorAddNew = async () => {
    dispatch(setwizardPageNumber(6));
    dispatch(setCheckPage('SummaryPage'));
    dispatch(setwizardPageName('directors'));
  };

  const uploadDocumentsAddNew = async () => {
    dispatch(setwizardPageNumber(6));
    dispatch(setCheckPage('SummaryPage'));
    dispatch(setwizardPageName('uploaddoc'));
  };

  useEffect(() => {
    if (typeof uploadDocumentsDetails.organizationalDocument === "string" && uploadDocumentsDetails.organizationalDocument.startsWith("data:image")) {
      setSrcModal1(uploadDocumentsDetails.organizationalDocument);
    }
    if (typeof uploadDocumentsDetails.proofPhysicalBusinessAddress === "string" && uploadDocumentsDetails.proofPhysicalBusinessAddress.startsWith("data:image")) {
      setSrcModal2(uploadDocumentsDetails.proofPhysicalBusinessAddress);
    }
  }, [uploadDocumentsDetails.organizationalDocument, uploadDocumentsDetails.proofPhysicalBusinessAddress]);

  const [activeAccordion, setActiveAccordion] = useState('');

  const groupedData = Array.isArray(dataArray) ? dataArray.reduce((acc, item) => {
    const combinedKey = `${item?.firstName || 'Unknown'} ${item?.lastName || ''}`.trim();
    if (!acc[combinedKey]) {
      acc[combinedKey] = [];
    }
    acc[combinedKey].push(item);
    return acc;
  }, {} as any) : {};

  const [activeDirectorAccordion, setActiveDirectorAccordion] = useState('');

  const groupedDirectorData = Array.isArray(directorsDataArray) ? directorsDataArray.reduce((acc, item) => {
    const combinedKey = `${item?.firstName || 'Unknown'} ${item?.lastName || ''}`.trim();
    if (!acc[combinedKey]) {
      acc[combinedKey] = [];
    }
    acc[combinedKey].push(item);
    return acc;
  }, {} as any) : {};

  const [srcModal1, setSrcModal1] = useState<string | null>(null);
  const [showModal1, setShowModal1] = useState(false);
  const modalRef1 = useRef<string | null>(null);

  const [srcModal2, setSrcModal2] = useState<string | null>(null);
  const [showModal2, setShowModal2] = useState(false);
  const modalRef2 = useRef<string | null>(null);

  const handleShowModal1 = () => { setShowModal1(true); };
  const handleCloseModal1 = async () => { setShowModal1(false); };

  const updateSrcModal1 = (newState: any) => {
    setSrcModal1(newState);
    dispatch(setUploadDocumentDetails({
      ...uploadDocumentsDetails,
      organizationalDocument: newState,
    }));
    const parts = newState.split(',');
    if (parts.length === 2) {
      const businessDocument: any = parts[1];
    }
  };

  const handleModal1CrossIconClick = () => {
    dispatch(setUploadDocumentDetails({
      ...uploadDocumentsDetails,
      organizationalDocument: '',
    }));
  };

  const handleShowModal2 = () => { setShowModal2(true); };
  const handleCloseModal2 = async () => { setShowModal2(false); };

  const updateSrcModal2 = (newState: any) => {
    setSrcModal2(newState);
    dispatch(setUploadDocumentDetails({
      ...uploadDocumentsDetails,
      proofPhysicalBusinessAddress: newState,
    }));
    const parts = newState.split(',');
    if (parts.length === 2) {
      const businessDocument: any = parts[1];
    }
  };

  const handleModal2CrossIconClick = () => {
    dispatch(setUploadDocumentDetails({
      ...uploadDocumentsDetails,
      proofPhysicalBusinessAddress: '',
    }));
  };

  const [isChecked1, setIsChecked1] = useState(certificationDetails?.certification1 !== false);
  const [isChecked2, setIsChecked2] = useState(certificationDetails?.certification2 !== false);

  useEffect(() => {
    if (certificationDetails?.certification1 !== undefined) {
      setIsChecked1(certificationDetails.certification1);
    }
    if (certificationDetails?.certification2 !== undefined) {
      setIsChecked2(certificationDetails.certification2);
    }
  }, [certificationDetails]);

  const handleCheckbox1Change = (e: any) => { setIsChecked1(e.target.checked); };
  const handleCheckbox2Change = (e: any) => { setIsChecked2(e.target.checked); };

  return (
    <>
      <SelfieCameraModal
        show={showModal1}
        handleClose={handleCloseModal1}
        title=""
        ref={modalRef1}
        side=""
        updateSrc={updateSrcModal1}
      />
      <SelfieCameraModal
        show={showModal2}
        handleClose={handleCloseModal2}
        title=""
        ref={modalRef2}
        side=""
        updateSrc={updateSrcModal2}
      />
      <Container fluid className="px-0 px-md-3">
        <Row className="g-0">
          <Col md={12} className=" text-center">
            <AccountCircle sx={{ fontSize: 50 }} style={{ color: "#00D084" }} />
            <h3 className="text-center mt-3">{t('kyc.confirm_info')}</h3>
            <span className="text-secondary">
              {t('kyc.confirm_secure')}
            </span>
          </Col>
        </Row>
        <Row className="g-0">
          <Col md={{ span: 8, offset: 2 }} className=" mb-5 mt-4 rounded-3 px-0 px-md-3">
            <Form className="p-2 p-md-3" noValidate={true}>
              <div className="accordion" id="accordionExample">
                <div className="accordion-item border-0 mb-2">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button  accordion_btn text-primary fw-bold px-4 "
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      {t('kyc.entity_nav_business_info')}
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
  <div className="d-flex flex-column">
    <div className="d-flex align-items-center">
      <DescriptionOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                        <label className="form-label mb-0 px-2 fw-bold">
                          {t('kyc.company_details', 'Company Details')}
                        </label>
    </div>
    
  </div>
  { !businessInfoEditMode ? (
    <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={businessInfoToggleEditMode}>
      <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
      <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
    </div>
  ) : (
    <div className="d-flex align-items-center gap-2 ms-3">
      <button type="button" className="btn btn-outline-dark btn-sm rounded-5 px-3 py-1" style={{ fontSize: "13px" }} onClick={handleBusinessInfoCancel}>Cancel</button>
      <button type="button" className="btn btn-sm rounded-5 px-3 py-1 border-0 text-white" style={{ background: "#00D084", fontSize: "13px" }} onClick={handleBusinessInfoSave}>Save</button>
    </div>
  )}
</div>
                      <Row className="mt-1">
                        <Col md={6} className="">
                          <label className="form-label mb-0">
                            {t('kyc.summary_diff_name_label')}
                          </label>
                          <br />
                          {businessInfoEditMode ? (
                            <Field
                              name="isBusinessDiffName"
                              component="select"
                              className="form-control form-select rounded-5 px-3 py-2 mb-1 mt-2"
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </Field>
                          ) : (
                            <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                              {businessAddressDetails.isBusinessDiffName}
                            </label>
                          )}
                        </Col>
                        <Col md={6} className="">
                          <label className="form-label mb-0">
                            {t('kyc.tax_id_label')}
                          </label>
                          <br />
                          {businessInfoEditMode ? (
                            <Field
                              name="taxID"
                              type="text"
                              component={renderField}
                              className="form-control mb-1 mt-2"
                            />
                          ) : (
                            <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                              {businessAddressDetails.taxID}
                            </label>
                          )}
                        </Col>
                      </Row>
                      <Row className="mt-1">
                        <Col md={6} className="">
                          <label className="form-label mb-0">
                            {t('kyc.date_of_formation')}
                          </label>
                          <br />
                          {businessInfoEditMode ? (
                            <Field
                              name="businessDateOfFormation"
                              type="date"
                              component={renderField}
                              className="form-control mb-1 mt-2"
                            />
                          ) : (
                            <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                              {businessAddressDetails.businessDateOfFormation}
                            </label>
                          )}
                        </Col>
                        <Col md={6} className="">
                          <label className="form-label mb-0">
                            {t('kyc.summary_website_label')}
                          </label>
                          <br />
                          {businessInfoEditMode ? (
                            <Field
                              name="isBusinessWebsite"
                              component="select"
                              className="form-control form-select rounded-5 px-3 py-2 mb-1 mt-2"
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </Field>
                          ) : (
                            <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                              {businessAddressDetails.isBusinessWebsite === "No" ? "No" : (entityAccountBusinessDetails?.businessWebsiteName || "-")}
                            </label>
                          )}
                        </Col>
                      </Row>

                      <Row className="mt-1">
                        <Col md={12} className="">
                          <label className="form-label mb-0">
                            {t('kyc.summary_business_desc_label')}
                          </label>
                          <br />
                          {businessInfoEditMode ? (
                            <div className="mt-2">
                              <Field
                                name="desBusinessModel"
                                component={renderCustomMultiLineTextArea}
                              />
                            </div>
                          ) : (
                            <div className="form-label custom_ConfirmReg_Label mb-1 mt-2" style={{ whiteSpace: 'pre-wrap' }}>
                              {businessAddressDetails.desBusinessModel}
                            </div>
                          )}
                        </Col>
                      </Row>

                      <Row className="mt-1">
                        <Col md={6} className="">
                          <label className="form-label mb-0">
                            {t('kyc.num_employees')}
                          </label>
                          <br />
                          {businessInfoEditMode ? (
                            <Field
                              name="numberOfEmployees"
                              component="select"
                              className="form-control form-select rounded-5 px-3 py-2 mb-1 mt-2"
                            >
                              <option>10-100</option>
                              <option>101-500</option>
                              <option>501-1000</option>
                              <option>1001-1500</option>
                              <option>1500+</option>
                            </Field>
                          ) : (
                            <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                              {businessAddressDetails.numberOfEmployees}
                            </label>
                          )}
                        </Col>
                      </Row>
                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
  <div className="d-flex flex-column">
    <div className="d-flex align-items-center">
      <BadgeOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                        <label className="form-label mb-0 px-2 fw-bold">
                          {t('kyc.physical_business_address')}
                        </label>
    </div>
  </div>
  { !physicalBusinessInfoEditMode ? (
    <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={physicalBusinessInfoToggleEditMode}>
      <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
      <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
    </div>
  ) : (
    <div className="d-flex align-items-center gap-2 ms-3">
      <button type="button" className="btn btn-outline-dark btn-sm rounded-5 px-3 py-1" style={{ fontSize: "13px" }} onClick={handlePhysicalBusinessInfoCancel}>Cancel</button>
      <button type="button" className="btn btn-sm rounded-5 px-3 py-1 border-0 text-white" style={{ background: "#00D084", fontSize: "13px" }} onClick={handlePhysicalBusinessInfoSave}>Save</button>
    </div>
  )}
</div>
                      <div>
                        <Row className="mt-1">
                          <Col md={6} className="">
                            <label className="form-label mb-0">
                              {t('kyc.country_of_residence')}
                            </label>
                            <br />
                            {physicalBusinessInfoEditMode ? (
                              <div className="dropdown">
                                <Button
                                  className="form-control form-select text-start px-3 rounded-5 border mb-1 mt-2"
                                  type="button"
                                  name="physicalBusinessCountry"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  variant=""
                                >
                                  {formValues.physicalBusinessCountry ? (
                                    <>
                                      <img
                                        src={
                                          countriesData.find(
                                            (country) =>
                                              country.name ===
                                              formValues.physicalBusinessCountry
                                          )?.image
                                        }
                                        alt={formValues.physicalBusinessCountry}
                                        style={{ width: "20px", marginRight: "5px" }}
                                      />
                                      {formValues.physicalBusinessCountry}
                                    </>
                                  ) : (
                                    "Select a country"
                                  )}
                                </Button>
                                <ul className="dropdown-menu w-100 rounded-4 hide-scroll border-0 shadow">
                                  {countriesData.map((country) => (
                                    <li key={country.code}>
                                      <span
                                        className="dropdown-item"
                                        onClick={() =>
                                          props.change("physicalBusinessCountry", country.name)
                                        }
                                      >
                                        <img
                                          src={country.image}
                                          alt={country.name}
                                          style={{ width: "20px", marginRight: "5px" }}
                                        />
                                        {country.name}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ) : (
                              <label className="form-label custom_ConfirmReg_Label  mb-1 mt-2">
                                <>
                                  <img
                                    src={
                                      countriesData.find(
                                        (country) =>
                                          country.name ===
                                          physicalBusinessAddressDetails.physicalBusinessAddressCountry
                                      )?.image
                                    }
                                    style={{ width: "20px", marginRight: "5px" }}
                                  />
                                  {physicalBusinessAddressDetails.physicalBusinessAddressCountry}
                                </>
                              </label>
                            )}
                          </Col>
                          <Col md={6} className="">
                            <label className="form-label mb-0">{t('kyc.city')}</label>
                            <br />
                            {physicalBusinessInfoEditMode ? (
                              <Field
                                name="physicalBusinessCity"
                                type="text"
                                component={renderField}
                                className="form-control mb-1 mt-2"
                              />
                            ) : (
                              <label className="form-label custom_ConfirmReg_Label  mb-1 mt-2">
                                {physicalBusinessAddressDetails.physicalBusinessAddressCity}
                              </label>
                            )}
                          </Col>
                        </Row>
                        <Row className=" mt-1">
                          <Col md={6} className="">
                            <label className="form-label mb-0 mt-2">
                              {t('kyc.state_province')}
                            </label>
                            <br />
                            {physicalBusinessInfoEditMode ? (
                              <div className="dropdown">
                                <Button
                                  className="form-control form-select rounded-5 text-start px-3 mt-2 mb-1 btn border"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  variant=""
                                >
                                  {formValues.physicalBusinessState
                                    ? formValues.physicalBusinessState
                                    : "Select State"}
                                </Button>
                                <ul className="dropdown-menu w-100 rounded-4 hide-scroll shadow border-0">
                                  {countriesStateData.map(
                                    (country) =>
                                      country.name === formValues.physicalBusinessCountry &&
                                      country.states &&
                                      country.states.map((state) => (
                                        <li
                                          key={state.id}
                                          className="dropdown-item"
                                          onClick={() =>
                                            props.change("physicalBusinessState", state.name)
                                          }
                                        >
                                          {state.name}
                                        </li>
                                      ))
                                  )}
                                </ul>
                              </div>
                            ) : (
                              <label className="form-label custom_ConfirmReg_Label  mb-1 mt-2">
                                {physicalBusinessAddressDetails.physicalBusinessAddressState}
                              </label>
                            )}
                          </Col>
                          <Col md={6} className="">
                            <label className="form-label mb-0 mt-2">
                              {t('kyc.zip_postal')}
                            </label>
                            <br />
                            {physicalBusinessInfoEditMode ? (
                              <Field
                                name="physicalBusinessPostalCode"
                                type="text"
                                component={renderField}
                                className="form-control mb-1 mt-2"
                              />
                            ) : (
                              <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                                {physicalBusinessAddressDetails.physicalBusinessAddressZip}
                              </label>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-1">
                          <Col md={6} className="">
                            <label className="form-label mb-0 mt-2">
                              {t('kyc.street_address')}
                            </label>
                            <br />
                            {physicalBusinessInfoEditMode ? (
                              <Field
                                name="physicalBusinessStreetAddress"
                                type="text"
                                component={renderField}
                                className="form-control mb-1 mt-2"
                              />
                            ) : (
                              <label className="form-label custom_ConfirmReg_Label  mb-1 mt-2">
                                {physicalBusinessAddressDetails.physicalBusinessStreetAddress}
                              </label>
                            )}
                          </Col>
                        </Row>
                      </div>

                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
  <div className="d-flex flex-column">
    <div className="d-flex align-items-center">
      <HomeOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                        <label className="form-label mb-0 px-2 fw-bold">
                          {t('kyc.entity_nav_account_use')}
                        </label>
    </div>
  </div>
  { !accountUseEditMode ? (
    <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={accountUseToggleEditMode}>
      <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
      <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
    </div>
  ) : (
    <div className="d-flex align-items-center gap-2 ms-3">
      <button type="button" className="btn btn-outline-dark btn-sm rounded-5 px-3 py-1" style={{ fontSize: "13px" }} onClick={handleAccountUseCancel}>Cancel</button>
      <button type="button" className="btn btn-sm rounded-5 px-3 py-1 border-0 text-white" style={{ background: "#00D084", fontSize: "13px" }} onClick={handleAccountUseSave}>Save</button>
    </div>
  )}
</div>
                      <Row className="mt-1">
                        <Col md={12} className="">
                          <label className="form-label mb-0">
                            {t('kyc.reason_for_account')}
                          </label>
                          <br />
                          {accountUseEditMode ? (
                            <Field
                              name="reasonForUsingAccount"
                              type="text"
                              component={renderField}
                              className="form-control mb-1 mt-2"
                            />
                          ) : (
                            <label className="form-label custom_ConfirmReg_Label  mb-1 mt-2">
                              {accountUseDetails.reasonForUsingAccount || accountUseDetails.reasonForAccountUse}
                            </label>
                          )}
                        </Col>
                      </Row>

                      <Row className=" mt-1">
                        <Col md={12} className="">
                          <label className="form-label mb-0 mt-2">
                            {t('kyc.customers_located_q')}
                          </label>
                          <br />
                          {accountUseEditMode ? (
                            <div className="row">
                              <div className="col-md-4 mt-2">
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox1" label="US" checked={checkboxes.checkbox1} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox2" label="UK" checked={checkboxes.checkbox2} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox3" label="Africa" checked={checkboxes.checkbox3} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox4" label="Other Oceania" checked={checkboxes.checkbox4} onChange={handleCheckboxChange} required />
                                </div>
                              </div>
                              <div className="col-md-4 mt-2">
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox5" label="Canada" checked={checkboxes.checkbox5} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox6" label="EU" checked={checkboxes.checkbox6} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox7" label="Asia" checked={checkboxes.checkbox7} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox8" label="Not Applicable" checked={checkboxes.checkbox8} onChange={handleCheckboxChange} required />
                                </div>
                              </div>
                              <div className="col-md-4 mt-2">
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox9" label="LATAM" checked={checkboxes.checkbox9} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox10" label="Other Europe" checked={checkboxes.checkbox10} onChange={handleCheckboxChange} required />
                                </div>
                                <div className="custom-checkbox">
                                  <Form.Check type="checkbox" id="checkbox11" label="Australia" checked={checkboxes.checkbox11} onChange={handleCheckboxChange} required />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <label className="form-label custom_ConfirmReg_Label  mb-1 mt-2 ">
                              {accountUseDetails.accountUseCustomerLocated || accountUseDetails.customersLocated || accountUseDetails.customersLocation}
                            </label>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                <div className="accordion-item border-0 mb-2">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button accordion_btn collapsed text-primary fw-bold px-4"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      {t('kyc.entity_nav_related_parties')}
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
  <div className="d-flex flex-column">
    <div className="d-flex align-items-center">
      <DescriptionOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                        <label className="form-label mb-0 px-2 fw-bold">
                          {t('kyc.entity_nav_auth_rep')}
                        </label>
    </div>
    
  </div>
  <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={authorizedRepToggleEditMode}>
    <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
    <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
  </div>
</div>
                      <div className="mt-2 mb-4">
                        {authorizedRepresentativeDetails?.firstName && (
                          <MemberSummaryCard member={authorizedRepresentativeDetails} roleType="authRep" />
                        )}
                      </div>
                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
                        <div className="d-flex flex-column">
                          <div className="d-flex align-items-center">
                            <BadgeOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                            <label className="form-label mb-0 px-2 fw-bold">
                              {t('kyc.entity_nav_beneficial_owners')}
                            </label>
                          </div>
                      </div>
                      { !beneficialOwnerEditMode ? (
                        <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={beneficialOwnerToggleEditMode}>
                          <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
                          <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center gap-2 ms-3">
                          <button type="button" className="btn btn-outline-dark btn-sm rounded-5 px-3 py-1" style={{ fontSize: "13px" }} onClick={handleBeneficialOwnerCancel}>Cancel</button>
                          <button type="button" className="btn btn-sm rounded-5 px-3 py-1 border-0 text-white" style={{ background: "#00D084", fontSize: "13px" }} onClick={handleBeneficialOwnerSaveAll}>Save</button>
                        </div>
                      )}
                      </div>
                      <div>
                        {allBeneficialOwnersDeleted && (
                          <Button
                            className="btn btn-secondary rounded-5  mt-2"
                            onClick={beneficialOwnerAddNew}
                            style={{ background: "#0B1628" }}
                          >
                            {t('common.add_new')}
                          </Button>
                        )}
                      </div>

                      <div>
                        {dataArray.map((item: any, innerIndex: any) => (
                          <MemberSummaryCard key={innerIndex} member={item} roleType="beneficialOwner" />
                        ))}
                      </div>                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
                        <div className="d-flex flex-column">
                          <div className="d-flex align-items-center">
                            <BadgeOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                            <label className="form-label mb-0 px-2 fw-bold">
                              {t('kyc.entity_nav_directors')}
                            </label>
                          </div>
                      </div>
                      { !directorEditMode ? (
                        <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={directorToggleEditMode}>
                          <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
                          <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center gap-2 ms-3">
                          <button type="button" className="btn btn-outline-dark btn-sm rounded-5 px-3 py-1" style={{ fontSize: "13px" }} onClick={handleDirectorCancel}>Cancel</button>
                          <button type="button" className="btn btn-sm rounded-5 px-3 py-1 border-0 text-white" style={{ background: "#00D084", fontSize: "13px" }} onClick={handleDirectorSaveAll}>Save</button>
                        </div>
                      )}
                      </div>
                      <div>
                        {allDirectorsDeleted && (
                          <Button
                            className="btn btn-secondary rounded-5  mt-2"
                            onClick={directorAddNew}
                            style={{ background: "#0B1628" }}
                          >
                            {t('common.add_new')}
                          </Button>
                        )}
                      </div>
                      <div>
                        {directorsDataArray.map((item: any, innerIndex: any) => (
                          <MemberSummaryCard key={innerIndex} member={item} roleType="director" />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item border-0 mb-2">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button accordion_btn collapsed text-primary fw-bold px-4"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      {t('kyc.entity_nav_documents')}
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
  <div className="d-flex flex-column">
    <div className="d-flex align-items-center">
      <DescriptionOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                        <label className="form-label mb-0 px-2 fw-bold">
                          {t('kyc.uploaded_documents')}
                        </label>
    </div>
    
  </div>
  <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={uploadDocumentsAddNew}>
    <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
    <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
  </div>
</div>
                      <Row className="mt-1">
                          <Col md={6} className="">
                            <label className="form-label mb-0">
                              {t('kyc.org_docs')}
                          </label>
                          <br />
                          {(() => {
                            const docs = Array.isArray(uploadDocumentsDetails.organizationalDocument)
                              ? uploadDocumentsDetails.organizationalDocument
                              : [uploadDocumentsDetails.organizationalDocument].filter(Boolean);

                            return (
                              <div className="d-flex flex-wrap gap-2">
                                {docs.map((docItem: any, index: number) => {
                                  const rawUrl = typeof docItem === 'string' ? docItem : (docItem?.url || docItem?.filename || docItem?.id || "");
                                  const filename = typeof docItem === 'string' ? "" : (docItem?.filename || "");
                                  
                                  let url = rawUrl;
                                  if (url && typeof url === 'string' && !url.startsWith('data:image') && !url.startsWith('http://') && !url.startsWith('https://')) {
                                    // bare UUID or relative path — prepend API base
                                    const name = url.includes('/') ? url.split('/').pop() : url;
                                    url = `${config.NODE_API_BASE_URL_V2}/file/${name}`;
                                  } else if (url && typeof url === 'string' && !url.startsWith('data:image') && url.includes('/file/')) {
                                    // full URL from bucket — rewrite to go through our local backend
                                    const name = url.split('/file/').pop();
                                    url = `${config.NODE_API_BASE_URL_V2}/file/${name}`;
                                  }
                                  
                                  const type = getFileType(url, filename);

                                  if (isImageBase64(url) || type === 'Image') {
                                    return (
                                      <img
                                        key={index}
                                        src={url}
                                        alt={filename || "Document"}
                                        className="rounded-1 img-fluid mb-2"
                                        style={{ width: 'calc(50% - 0.5rem)', cursor: 'pointer' }}
                                        onClick={() => window.open(url, '_blank')}
                                        onError={(e) => {
                                          const img = e.target as HTMLImageElement;
                                          const retries = parseInt(img.getAttribute('data-retries') || '0', 10);
                                          if (retries < 5) {
                                            setTimeout(() => {
                                              img.setAttribute('data-retries', (retries + 1).toString());
                                              img.src = url + '?t=' + Date.now();
                                            }, 1000);
                                          } else {
                                            const parent = img.parentElement;
                                            if (parent) {
                                              const div = document.createElement('div');
                                              div.className = 'bg-sky pb-1 d-flex flex-column align-items-center mb-2 rounded-3 py-3';
                                              div.style.cssText = 'cursor:pointer;width:calc(50% - 0.5rem)';
                                              div.onclick = () => window.open(url, '_blank');
                                              div.innerHTML = '<span style="font-size:40px;color:#00D084">📄</span><p class="small mt-2 mb-0 text-secondary">View File</p>';
                                              parent.replaceChild(div, img);
                                            }
                                          }
                                        }}
                                      />
                                    );
                                  } else if (url) {
                                    return (
                                      <div key={index} className="bg-sky pb-1 d-flex flex-column align-items-center mb-2 rounded-3 py-3" style={{ cursor: 'pointer', width: 'calc(50% - 0.5rem)' }} onClick={() => window.open(url, '_blank')}>
                                        <DescriptionOutlined sx={{ fontSize: 40 }} style={{ color: "#00D084" }} />
                                        <p className="small mt-2 mb-0 text-secondary">View {type}</p>
                                      </div>
                                    );
                                  }
                                  return null;
                                })}
                              </div>
                            );
                          })()}
                        </Col>
                          <Col md={6} className="">
                            <label className="form-label mb-0">
                              {t('kyc.proof_physical_bus_addr')}
                          </label>
                          <br />
                          {(() => {
                            const docs = Array.isArray(uploadDocumentsDetails.proofPhysicalBusinessAddress)
                              ? uploadDocumentsDetails.proofPhysicalBusinessAddress
                              : [uploadDocumentsDetails.proofPhysicalBusinessAddress].filter(Boolean);

                            return (
                              <div className="d-flex flex-wrap gap-2">
                                {docs.map((docItem: any, index: number) => {
                                  const rawUrl = typeof docItem === 'string' ? docItem : (docItem?.url || docItem?.filename || docItem?.id || "");
                                  const filename = typeof docItem === 'string' ? "" : (docItem?.filename || "");
                                  
                                  let url = rawUrl;
                                  if (url && typeof url === 'string' && !url.startsWith('data:image') && !url.startsWith('http://') && !url.startsWith('https://')) {
                                    const name = url.includes('/') ? url.split('/').pop() : url;
                                    url = `${config.NODE_API_BASE_URL_V2}/file/${name}`;
                                  } else if (url && typeof url === 'string' && !url.startsWith('data:image') && url.includes('/file/')) {
                                    const name = url.split('/file/').pop();
                                    url = `${config.NODE_API_BASE_URL_V2}/file/${name}`;
                                  }
                                  
                                  const type = getFileType(url, filename);

                                  if (isImageBase64(url) || type === 'Image') {
                                    return (
                                      <img
                                        key={index}
                                        src={url}
                                        alt={filename || "Document"}
                                        className="rounded-1 img-fluid mb-2"
                                        style={{ width: 'calc(50% - 0.5rem)', cursor: 'pointer' }}
                                        onClick={() => window.open(url, '_blank')}
                                        onError={(e) => {
                                          const parent = (e.target as HTMLImageElement).parentElement;
                                          if (parent) {
                                            const div = document.createElement('div');
                                            div.className = 'bg-sky pb-1 d-flex flex-column align-items-center mb-2 rounded-3 py-3';
                                            div.style.cssText = 'cursor:pointer;width:calc(50% - 0.5rem)';
                                            div.onclick = () => window.open(url, '_blank');
                                            div.innerHTML = '<span style="font-size:40px;color:#00D084">📄</span><p class="small mt-2 mb-0 text-secondary">View File</p>';
                                            parent.replaceChild(div, e.target as HTMLImageElement);
                                          }
                                        }}
                                      />
                                    );
                                  } else if (url) {
                                    return (
                                      <div key={index} className="bg-sky pb-1 d-flex flex-column align-items-center mb-2 rounded-3 py-3" style={{ cursor: 'pointer', width: 'calc(50% - 0.5rem)' }} onClick={() => window.open(url, '_blank')}>
                                        <DescriptionOutlined sx={{ fontSize: 40 }} style={{ color: "#00D084" }} />
                                        <p className="small mt-2 mb-0 text-secondary">View {type}</p>
                                      </div>
                                    );
                                  }
                                  return null;
                                })}
                              </div>
                            );
                          })()}
                        </Col>
                      </Row>
                      {uploadDocumentsDetails.physicalBusinessAddressDocumentInfo && (
                        <Row className="mt-2">
                          <Col md={12} className="">
                            <label className="form-label mb-0 mt-2">
                              {t('kyc.additional_info_short')}
                            </label>
                            <br />
                            <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                              {uploadDocumentsDetails.physicalBusinessAddressDocumentInfo}
                            </label>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </div>
                </div>
                <div className="accordion-item border-0">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button accordion_btn collapsed text-primary fw-bold px-4 letter-spacing-fix"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      {t('kyc.entity_nav_certification')}
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="mb-2 d-flex align-items-start justify-content-between w-100">
  <div className="d-flex flex-column">
    <div className="d-flex align-items-center">
      <FactCheckOutlined sx={{ fontSize: 24 }} style={{ color: "#00D084" }} />
                        <label className="form-label mb-0 px-2 fw-bold">
                          {t('kyc.declaration_signoff', 'Declaration & Sign-off')}
                        </label>
    </div>
  </div>
  { !certificationEditMode ? (
    <div className="d-flex align-items-center cursor-pointer ms-3" style={{ cursor: 'pointer' }} onClick={certificationToggleEditMode}>
      <EditOutlined sx={{ fontSize: 20 }} className="me-1" style={{ color: "#00D084" }} />
      <span className="fw-semibold" style={{ color: "#00D084", fontSize: "14px" }}>Edit</span>
    </div>
  ) : (
    <div className="d-flex align-items-center gap-2 ms-3">
      <button type="button" className="btn btn-outline-dark btn-sm rounded-5 px-3 py-1" style={{ fontSize: "13px" }} onClick={handleCertificationCancel}>Cancel</button>
      <button type="button" className="btn btn-sm rounded-5 px-3 py-1 border-0 text-white" style={{ background: "#00D084", fontSize: "13px" }} onClick={handleCertificationSave}>Save</button>
    </div>
  )}
</div>
                      <div>
                        { (certificationEditMode || certificationDetails?.certificationNotes) && (
                          <Row className="mt-1 mb-3">
                            <Col md={12}>
                                  <label className="form-label small fw-medium  ">
                                    {" "}
                                    {t('kyc.summary_cert_notes_label')}
                                  </label>
                                  <br />
                                  {certificationEditMode ? (
                                    <Field
                                      name="certificationNotes"
                                      component="textarea"
                                      className="form-control h-auto rounded-4 mt-2"
                                      rows={4}
                                      placeholder={t('kyc.cert_notes_ph')}
                                    />
                                  ) : (
                                    <label className="form-label custom_ConfirmReg_Label mb-1 mt-2">
                                      {certificationDetails?.certificationNotes || ""}
                                    </label>
                                  )}
                            </Col>
                          </Row>
                        )}
                        <Row className="mt-1">
                          <Col md={12}>
                            <label className="form-label small fw-medium  letter-spacing-fix">
                              {" "}
                              {t('kyc.cert_please_certify')}
                            </label>
                            <div className="row">
                              <div className="col-md-12 mt-2">
                                <div className="mb-2">
                                  <Form.Check
                                    checked={isChecked1}
                                    onChange={handleCheckbox1Change}
                                    className={`text-secondary  ${!isChecked1 ? "reg-checkbox border-danger" : ""}`}
                                    label={
                                      <span className="form-check-label text-secondary small">
                                        {t('kyc.cert1_text')}
                                      </span>
                                    }
                                  />
                                </div>
                                <div className="mb-2">
                                  <Form.Check
                                    checked={isChecked2}
                                    onChange={handleCheckbox2Change}
                                    className={`text-secondary ${!isChecked2 ? "reg-checkbox border-danger" : ""}`}
                                    label={
                                      <span className="form-check-label text-secondary small">
                                        {t('kyc.cert2_text')}
                                      </span>
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 d-flex flex-column flex-md-row justify-content-between gap-3">
                <Button
                  className="btn py-2 px-4 rounded-5 w-100 w-md-auto order-2 order-md-1"
                  variant="outline-secondary"
                  onClick={() => {
                    navigate("/personal_account_created");
                    localStorage.removeItem('pageName');
                    localStorage.removeItem('pageNumber');
                  }}
                >
                  {t('common.save_exit')}
                </Button>
                <Button
                  className="btn btn-primary py-2 px-4 rounded-5 w-100 w-md-auto order-1 order-md-2"
                  type="submit"
                  onClick={async (e) => {
                    e.preventDefault();
                    try {
                      const response = await submitEntityKycDraft(userID);
                      if (response) {
                        notifySuccess("KYC Application submitted successfully!");
                        navigate("/personal_account_created");
                        localStorage.removeItem('pageName');
                        localStorage.removeItem('pageNumber');
                      } else {
                        console.error("Submission failed. Please try again.");
                      }
                    } catch (error) {
                      console.error("Submission error:", error);
                      console.error("Something went wrong during submission.");
                    }
                  }}
                >
                  {t('common.continue')}
                </Button>
              </div>
            </Form>
          </Col>
          <Col md={3}></Col>
        </Row>
      </Container>
      <HelpBtn />
    </>
  );
};

const validate = (values: FormData) => {
  const errors: any = {};
  if (!values.isBusinessDiffName) errors.isBusinessDiffName = 'Required';
  if (!values.taxID) errors.taxID = 'Required';
  if (!values.businessDateOfFormation) errors.businessDateOfFormation = 'Required';
  if (!values.isBusinessWebsite) errors.isBusinessWebsite = 'Required';
  if (!values.desBusinessModel) errors.desBusinessModel = 'Required';
  if (!values.numberOfEmployees) errors.numberOfEmployees = 'Required';

  if (!values.physicalBusinessStreetAddress) errors.physicalBusinessStreetAddress = 'Required';
  if (!values.physicalBusinessCity) errors.physicalBusinessCity = 'Required';
  if (!values.physicalBusinessPostalCode) errors.physicalBusinessPostalCode = 'Required';

  if (!values.reasonForUsingAccount) errors.reasonForUsingAccount = 'Required';

  if (!values.authRepFirstName) errors.authRepFirstName = 'Required';
  if (!values.authRepLastName) errors.authRepLastName = 'Required';
  if (!values.authRepEmail) errors.authRepEmail = 'Required';

  return errors;
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    phoneno: state.entityAccount.authorizedRepresentativeDetails?.phoneNumber || "",
    physicalBusinessStreetAddress: state.entityAccount.physicalBusinessAddressDetails?.physicalBusinessStreetAddress || "",
    physicalBusinessPostalCode: state.entityAccount.physicalBusinessAddressDetails?.physicalBusinessAddressZip || "",
    physicalBusinessCity: state.entityAccount.physicalBusinessAddressDetails?.physicalBusinessAddressCity || "",
    physicalBusinessCountry: state.entityAccount.physicalBusinessAddressDetails?.physicalBusinessAddressCountry || "",
    physicalBusinessState: state.entityAccount.physicalBusinessAddressDetails?.physicalBusinessAddressState || "",
    firstName: state.entityAccount.entityAccountUserDetails?.firstName || "",
    lastName: state.entityAccount.entityAccountUserDetails?.lastName || "",
    isBusinessDiffName: state.entityAccount.businessAddressDetails?.isBusinessDiffName || "",
    taxID: state.entityAccount.businessAddressDetails?.taxID || "",
    businessDateOfFormation: state.entityAccount.businessAddressDetails?.businessDateOfFormation || "",
    isBusinessWebsite: state.entityAccount.businessAddressDetails?.isBusinessWebsite || "",
    desBusinessModel: state.entityAccount.businessAddressDetails?.desBusinessModel || "",
    numberOfEmployees: state.entityAccount.businessAddressDetails?.numberOfEmployees || "",
    reasonForUsingAccount: state.entityAccount.accountUseDetails?.reasonForUsingAccount || "",
    accountUseCity: state.entityAccount.accountUseDetails?.accountUseCity || "",
    accountUseState: state.entityAccount.accountUseDetails?.accountUseState || "",
    accountUseCustomerLocated: state.entityAccount.accountUseDetails?.accountUseCustomerLocated || "",
    authRepFirstName: state.entityAccount.authorizedRepresentativeDetails?.firstName || "",
    authRepLastName: state.entityAccount.authorizedRepresentativeDetails?.lastName || "",
    authRepEmail: state.entityAccount.authorizedRepresentativeDetails?.email || "",
    authRepPhoneNumber: state.entityAccount.authorizedRepresentativeDetails?.phoneNumber || "",
    authRepDateOfBirth: state.entityAccount.authorizedRepresentativeDetails?.dateOfBirth || "",
    authRepJobTitle: state.entityAccount.authorizedRepresentativeDetails?.jobTitle || "",
    authRepCountry: state.entityAccount.authorizedRepresentativeDetails?.authRepCountry || "",
    authRepSelectedFormID: state.entityAccount.authorizedRepresentativeDetails?.selectedFormID || "",
    certificationNotes: state.entityAccount.certificationDetails?.certificationNotes || "",
    organizationalDocument: state.entityAccount.uploadDocumentDetails?.organizationalDocument || "",
    proofPhysicalBusinessAddress: state.entityAccount.uploadDocumentDetails?.proofPhysicalBusinessAddress || "",
    physicalBusinessAddressDocumentInfo: state.entityAccount.uploadDocumentDetails?.physicalBusinessAddressDocumentInfo || ""
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: 'wizardSummary',
  enableReinitialize: true,
  validate,
})(SummaryForm);

export default connect(mapStateToProps)(form);
